module.exports = __webpack_public_path__ + "static/media/passport.6467d2be.png";